export default __webpack_public_path__ + "static/media/diceRoll2.55ad9bac.mp3";